export default __webpack_public_path__ + "images/fcfb0d73ba0a0090a93f4a0c8561973e.png";